import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import MaskItemNewArrivals from './mask-loading';
import { API, CURRENCY } from '../../../constants';
import { formatMoney } from '../../../services';

class HomeNewArraival extends Component {
  render() {
    const { newArrival, history, wording, basenameURL } = this.props;

    return (
      <section className="section-wrap-small new-arrivals pb-20">
        <div className="container">
          <h1 className="heading text-center relative heading-small uppercase bottom-line style-2">
            {wording.homePage.newArrivals.newArr}
          </h1>

          <div className="row items-grid">
            {!newArrival ? (
              <MaskItemNewArrivals />
            ) : (
                newArrival.map((item) => {
                  return (
                    <div
                      key={`new-${item.id}`}
                      className="col-md-3 col-sm-6 col-xs-12">
                      <div className="product-item mb-20">
                        <div className="product-img hover-1">
                          <div
                            className="background-img"
                            style={{
                              minWidth: '99.9%',
                              height: '380px',
                              backgroundImage: `url('${API.PRODUCT_IMG_URL}${item.img}')`
                            }}>
                            {/* <img
                                                            src={`${API.PRODUCT_IMG_URL}${item.img}`}
                                                            alt={item.img}
                                                        />
                                                        <img
                                                            src={`${API.PRODUCT_IMG_URL}${item.img}`}
                                                            alt={item.img}
                                                            className='back-img'
                                                        /> */}
                          </div>

                          {item.overTag && (
                            <span className="sold-out valign">
                              {wording.homePage.newArrivals.outOfStock}
                            </span>
                          )}

                          {item.tag && (
                            <div className="product-label label-left">
                              <span
                                className={
                                  item.tag === 'SALE'
                                    ? 'sale'
                                    : item.tag === 'HOT'
                                      ? 'hot'
                                      : null
                                }>
                                {item.tag}xxx
                            </span>
                            </div>
                          )}
                          {item.promotionName && (
                            <div className="product-label label-right">
                              <span className="pro">{item.promotionName}</span>
                            </div>
                          )}

                          <div
                            className="hover-overlay pointer"
                            onClick={() => {
                              history.push(
                                `${basenameURL}/product/${item.name
                                  .split(' ')
                                  .join('-')}`
                              );
                            }}></div>
                        </div>

                        <div className="product-details">
                          <h3>
                            <Link
                              to={`${basenameURL}/product/${item.name
                                .split(' ')
                                .join('-')}`}
                              className="btn-quickview">
                              <div className="product-title cut-text">
                                {item.name}
                              </div>
                            </Link>
                          </h3>
                          {item.promotionPrice > 0 && item.promotionPrice < item.price ? (
                            <span className='price'>
                              <del>
                                <span>{`${CURRENCY.B}${formatMoney(
                                  item.price
                                )}`}</span>
                              </del>
                              <ins>
                                <span className='ammount'>{`${
                                  CURRENCY.B
                                  }${formatMoney(
                                    item.promotionPrice
                                  )}`}</span>
                              </ins>
                            </span>
                          ) : (
                            <span className='price'>
                              <ins>
                                <span className='ammount'>{`${
                                  CURRENCY.B
                                  }${formatMoney(
                                    item.price
                                  )}`}</span>
                              </ins>
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })
              )}
          </div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = ({ home, language }) => ({
  newArrival: home.newArrival,
  wording: language.wording,
  basenameURL: language.basenameURL
});

export default withRouter(connect(mapStateToProps, null)(HomeNewArraival));
